enum Breakpoint {
    Small = 600,
    Medium = 800,
    Large = 1080,
    XLarge = 1280,
    XXLarge = 1440,
}

export default Breakpoint;
